<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">New property for this utsav</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <form [formGroup]="form" class="dialog-form" id="utsav-property-form" (ngSubmit)="submit()">
    <div class="field-row">
      <div class="field">
        <span class="field-label">Property name</span>
        <input type="text" class="text-box-active" formControlName="name" />
      </div>
      <div class="field">
        <label class="field-label" id="utsav-property-category-label">Category</label>
        <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
          <mat-select
            aria-labelledby="utsav-property-category-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="category"
          >
            @for(opt of categoryOptions; track opt.value){
            <mat-option [value]="opt.value">{{ opt.label }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="field">
      <span class="field-label">Address</span>
      <input type="text" class="text-box-active" formControlName="address" />
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Landmark</span>
        <input type="text" class="text-box-active" formControlName="landmark" />
      </div>
      <div class="field">
        <span class="field-label">Location URL</span>
        <input type="url" class="text-box-active" formControlName="locationUrl" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Latitude (optional)</span>
        <input type="number" step="any" class="text-box-active" formControlName="latitude" />
      </div>
      <div class="field">
        <span class="field-label">Longitude (optional)</span>
        <input type="number" step="any" class="text-box-active" formControlName="longitude" />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <span class="field-label">Contact Number (optional)</span>
        <input
          type="text"
          class="text-box-active"
          formControlName="contact"
          inputmode="numeric"
          maxlength="10"
          autocomplete="tel"
        />
      </div>
      <div class="field">
        <span class="field-label">Alternate Contact (optional)</span>
        <input
          type="text"
          class="text-box-active"
          formControlName="altContact"
          inputmode="numeric"
          maxlength="10"
          autocomplete="tel"
        />
      </div>
    </div>

    <div class="field-row">
      <div class="field">
        <label class="field-label" for="utsav-property-pincode">Pincode</label>
        <div class="input-status-wrapper">
          <input
            id="utsav-property-pincode"
            type="text"
            class="text-box-active"
            formControlName="pincode"
            inputmode="numeric"
            autocomplete="postal-code"
            maxlength="6"
            aria-describedby="utsav-property-pincode-message"
          />
          @if(isPincodeLoading){
          <span class="lookup-spinner" aria-label="Checking pincode"></span>
          }
        </div>
        @if(pincodeControl?.touched && pincodeControl?.hasError('pattern')){
        <span id="utsav-property-pincode-message" class="field-message field-error">
          Enter a valid 6-digit pincode.
        </span>
        } @else if(pincodeLookupMessage){
        <span
          id="utsav-property-pincode-message"
          class="field-message"
          [class.field-error]="pincodeLookupStatus === 'error'"
          [class.field-success]="pincodeLookupStatus === 'valid'"
        >
          {{ pincodeLookupMessage }}
        </span>
        }
      </div>
      <div class="field">
        <label class="field-label" for="utsav-property-state">State</label>
        <input
          id="utsav-property-state"
          type="text"
          class="text-box-active readonly-field"
          formControlName="state"
          readonly
        />
      </div>
      <div class="field">
        <label class="field-label" id="utsav-property-district-label">District</label>
        @if(districtList.length > 1){
        <mat-form-field
          class="ac-select-field"
          appearance="outline"
          subscriptSizing="dynamic"
        >
          <mat-select
            id="utsav-property-district"
            aria-labelledby="utsav-property-district-label"
            panelClass="ac-select-panel"
            [disableOptionCentering]="true"
            formControlName="district"
            placeholder="Select district"
            (selectionChange)="onDistrictChange()"
          >
            @for(district of districtList; track district){
            <mat-option [value]="district">{{ district }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @else {
        <input
          aria-labelledby="utsav-property-district-label"
          type="text"
          class="text-box-active readonly-field"
          formControlName="district"
          readonly
        />
        }
      </div>
    </div>

    <div class="section-title">Rooms</div>

    <div formArrayName="rooms" class="rooms">
      @for(room of rooms.controls; track room; let i = $index){
      <div class="room-row" [formGroupName]="i">
        <label class="room-field">
          <span class="field-label">Room no</span>
          <input class="text-box-active" formControlName="roomNumber" />
        </label>
        <label class="room-field">
          <span class="field-label">Floor</span>
          <input class="text-box-active" formControlName="floor" />
        </label>
        <label class="room-field">
          <span class="field-label">Capacity</span>
          <input class="text-box-active" type="number" formControlName="capacity" />
        </label>
        <div class="room-field">
          <span class="field-label">Room type</span>
          <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
            <mat-select
              panelClass="ac-select-panel"
              [disableOptionCentering]="true"
              formControlName="roomType"
            >
              @for(t of roomTypes; track t){ <mat-option [value]="t">{{ t }}</mat-option> }
            </mat-select>
          </mat-form-field>
        </div>
        <div class="room-field">
          <span class="field-label">Gender</span>
          <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
            <mat-select
              panelClass="ac-select-panel"
              [disableOptionCentering]="true"
              formControlName="gender"
            >
              @for(g of genders; track g){ <mat-option [value]="g">{{ g }}</mat-option> }
            </mat-select>
          </mat-form-field>
        </div>
        <button
          type="button"
          class="ac-secondary-small-btn remove-room-btn"
          [disabled]="rooms.length === 1 || isLoading"
          [attr.aria-label]="'Remove room row ' + (i + 1)"
          (click)="removeRoomRow(i)">
          Remove
        </button>
      </div>
      }
    </div>

    <button type="button" class="ac-secondary-btn add-room-btn" [disabled]="isLoading" (click)="addRoomRow()">Add room row</button>
  </form>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Close</button>
    <button
      type="submit"
      form="utsav-property-form"
      class="ac-primary-btn"
      [disabled]="isLoading || isPincodeLoading"
    >
      Create &amp; assign
    </button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
